// extracted by mini-css-extract-plugin
export default {"mainThanku":"Thanku_mainThanku__43lkF","image":"Thanku_image__7DTBs","counter":"Thanku_counter__PoeOc","madloba":"Thanku_madloba__he3+E","context":"Thanku_context__dboAG"};